import { Form } from "@inertiajs/react";

import TextField from "/components/TextField";
import TextArea from "/components/TextArea";
import Button from "/components/Button";

import styles from "./styles.module.css";

export default function PlaceForm({
  place = {},
  action,
  method,
  errors = {},
}) {
  return (
    <Form action={action} method={method} className={styles.fullFormContainer}>
      <TextField label="Name" name="name" placeholder="Eiffel Tower" errors={errors.name} />
      <TextArea label="Description" name="description" placeholder="The Eiffel Tower is a wrought-iron lattice tower on the Champ de Mars in Paris, France. It is named after the engineer Gustave Eiffel, whose company designed and built the tower from 1887 to 1889..." errors={errors.description} />
      <TextField label="Google Maps link" name="gmaps_url" placeholder="https://maps.app.goo.gl/cywABA2oM4p9LRuQ8" errors={errors.gmaps_url} />
      <Button type="submit">Save</Button>
    </Form>
  );
}
